import { render, staticRenderFns } from "./commentWriter.vue?vue&type=template&id=3a26217d"
import script from "./commentWriter.vue?vue&type=script&lang=js"
export * from "./commentWriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports